<template>
  <div class="text-no-wrap">
    <template v-if="item.deleted_at == null">
      <span v-if="item.is_active">
        <span
          :style="{ background: 'green' }"
          class="pa-1 d-inline-block mr-2 status-circle"
        ></span
        >{{ $t("goods.status_recorded") }}
      </span>
      <span v-else>
        <span
          :style="{ background: 'yellow' }"
          class="pa-1 d-inline-block mr-2 status-circle"
        ></span
        >{{ $t("goods.status_in_the_work") }}
      </span>
    </template>
    <template v-else>
 <span
     :style="{ background: 'grey' }"
     class="pa-1 d-inline-block mr-2 status-circle"
 ></span
 >{{ $t("goods.status_canceled") }}
    </template>
  </div>
</template>

<script>
export default {
  name: "GoodsMovementBasisStatus",
  props: ["item"],
  data: () => ({
    foo: "bar",
  }),
};
</script>

<style scoped></style>
